<template>
  <a-spin :spinning="loading">
    <div class="bots-list">
      <ConnectorCard create @create="handleShowCreate" />

      <ConnectorCard
        v-for="connector in connectorList"
        :key="connector.id"
        :connector="connector"
        @edit="goToConnectorEdit(connector.id)"
        @update="handleUpdate"
      />
    </div>
  </a-spin>

  <RestrictionChangePlanModal
    title="Realiza un upgrade y accede a todo el poder de Beex."
    v-model:open="openRestriction"
  >
    <template #description>
      Tu plan {{ PlanTypeText[plan] }} no incluye este módulo.
      Solicita un upgrade tu plan para potenciar tu ambiente de trabajo.
    </template>
  </RestrictionChangePlanModal>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";

import { Connector } from "@/@types/ivr";

import ConnectorCard from "@/app/ivr/bot/components/cards/ConnectorCard.vue";
import RestrictionChangePlanModal from "@/app/common/components/modals/RestrictionChangePlanModal.vue";
import { PlanType, PlanTypeText } from "@/app/common/types";
import { useStore } from "vuex";
import { ActionPlanStrategy } from "@/app/common/utils/enums";
import EventBus from "@/app/shared/utils/eventBus";

defineProps<{ connectorList: Connector[]; loading: boolean }>();

const emit = defineEmits<{
  (e: "update"): void;
}>();

const route = useRoute();
const router = useRouter();

const store = useStore();

const user = computed(() => store.getters["getDataUser"]);
const plan = computed(() => user.value?.change_custom_plan?.plan);
const openRestriction = ref(false);

const isAutomatic = route.path.includes("ivr-automatic");

const validateActionPlanHeader = () => {
  if (
    (isAutomatic && plan.value == PlanType.Digital) ||
    (!isAutomatic && [PlanType.Voice, PlanType.Digital].includes(plan.value))
  ) {
    store.commit("SET_ACTION_PLAN_HEADER", ActionPlanStrategy.Upgrade);
  } else {
    store.commit("SET_ACTION_PLAN_HEADER", null);
  }
};

EventBus.on("SHOW_RESTRICTION_PLAN", () => {
  openRestriction.value = true
});

watch(user, () => {
  validateActionPlanHeader();
})

watch(plan, () => {
  validateActionPlanHeader();
});

onMounted(() => {
  validateActionPlanHeader();
});

onUnmounted(() => {
  store.commit("SET_ACTION_PLAN_HEADER", null);
});

const handleShowCreate = () => {
  if (
    (isAutomatic && plan.value == PlanType.Digital) ||
    (!isAutomatic && [PlanType.Voice, PlanType.Digital].includes(plan.value))
  )
    openRestriction.value = true
  else
    router.push({
      name: "create-connector",
      query: route.query,
    });
}

const goToConnectorEdit = (connectorId: number) => {
    router.push({
      name: "edit-connector",
      params: {connectorId: connectorId},
      query: route.query,
    });
};

const handleUpdate = () => emit("update");

</script>

<style scoped lang="sass">
.bots-list
  width: calc(100% - 10px)
  gap: 12px
  display: grid
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr))
</style>
